import type { BaseDataItem, Video } from '@wix/thunderbolt-becky-types'
import { createDataNode, envRefs } from '@wix/thunderbolt-catharsis'
import type { ImageXDefinition, VideoBoxDefinition, WPhotoDefinition } from '@wix/thunderbolt-components'
import { ShapeDividerBuilderID } from './constants'

const createSvgDataNode = <Data extends BaseDataItem>(
	getDependencies: (item: Data) => ReturnType<typeof envRefs.parsedSvg> | undefined,
	key: string = 'resolvedSvg'
) =>
	createDataNode({
		getDependencies,
		toViewItem: (item, schemaDeps, resolvedSvg) => {
			const resolvedData = {
				...item,
				...(schemaDeps as any),
			}
			if (resolvedSvg) {
				resolvedData[key] = resolvedSvg
			}
			return resolvedData
		},
	})

const simpleGetDependencies = (item: BaseDataItem & { svgId: string }) =>
	item.svgId ? envRefs.parsedSvg(item.svgId) : undefined

const VectorImage = createSvgDataNode(simpleGetDependencies)
const SvgImage = createSvgDataNode(simpleGetDependencies)
const BreadcrumbsData = createSvgDataNode(simpleGetDependencies)
const RatingsInput = createSvgDataNode(simpleGetDependencies)
const StylableButton = createSvgDataNode(simpleGetDependencies)
const ShapeDivider = createSvgDataNode(simpleGetDependencies)
const ControlIconDesignData = createSvgDataNode(simpleGetDependencies)

const ShapeDividerStyleItem = createSvgDataNode((item: BaseDataItem & { cssCustomProperties: { svgId: string } }) => item?.cssCustomProperties?.svgId ? envRefs.parsedSvg(JSON.parse(item.cssCustomProperties.svgId)) : undefined)

const MediaPlayerProperties = createSvgDataNode(({ overrideMask }: VideoBoxDefinition['property']) =>
	overrideMask?.svgId ? envRefs.parsedSvg(overrideMask.svgId) : undefined
)
const WixVideo = createSvgDataNode(({ mask }: Video) => (mask?.svgId ? envRefs.parsedSvg(mask.svgId) : undefined))
const QuickActionBarItem = createSvgDataNode(({ icon }: BaseDataItem & { icon: string }) =>
	icon ? envRefs.parsedSvg(`svgshape.v2.Svg_${icon}`) : undefined
)

const WPhotoProperties = createSvgDataNode(({ overrideCrop }: WPhotoDefinition['property']) =>
	overrideCrop?.svgId ? envRefs.parsedSvg(overrideCrop.svgId) : undefined
)

const Image = createSvgDataNode(({ crop }: WPhotoDefinition['data']) =>
	crop?.svgId ? envRefs.parsedSvg(crop.svgId) : undefined
)

const ImageX = createSvgDataNode(({ mask }: ImageXDefinition['data']) =>
	mask?.svgId ? envRefs.parsedSvg(mask.svgId) : undefined
)

const SVGItem = createSvgDataNode(simpleGetDependencies)

export const shapeIdsDataNodes = {
	BreadcrumbsData,
	ControlIconDesignData,
	Image,
	ImageX,
	MediaPlayerProperties,
	QuickActionBarItem,
	RatingsInput,
	ShapeDivider,
	StylableButton,
	SVGItem,
	VectorImage,
	SvgImage,
	WixVideo,
	WPhotoProperties,
	[`${ShapeDividerBuilderID}.Style`]: ShapeDividerStyleItem,
}
